import { httpApi } from '@/api/http.api'

export type ServiceActivityDto = {
  id: string
  shortName: string
  description: string
  instruction: string
  laborCostPln: number
  deviceCategories: string[]
  hidden: boolean
  createdAt: string
  updatedAt: string
}

export type ServiceActivityRequest = {
  shortName: string
  description: string
  instruction: string
  laborCostPln: number
  deviceCategories: string[]
}

const SERVICE_ACTIVITIES = 'service-activities'

export const getServiceActivities = (): Promise<ServiceActivityDto[]> =>
  httpApi.get<ServiceActivityDto[]>(SERVICE_ACTIVITIES).then(({ data }) => data)

export const createServiceActivity = (payload: ServiceActivityRequest): Promise<ServiceActivityDto> =>
  httpApi.post<ServiceActivityDto>(SERVICE_ACTIVITIES, payload).then(({ data }) => data)

export const updateServiceActivity = (id: string, payload: ServiceActivityRequest): Promise<ServiceActivityDto> =>
  httpApi.put<ServiceActivityDto>(`${SERVICE_ACTIVITIES}/${id}`, payload).then(({ data }) => data)

export const updateServiceActivityVisibility = (id: string, hidden: boolean): Promise<ServiceActivityDto> =>
  httpApi.patch<ServiceActivityDto>(`${SERVICE_ACTIVITIES}/${id}/visibility`, { hidden }).then(({ data }) => data)

export const deleteServiceActivity = (id: string): Promise<void> =>
  httpApi.delete<void>(`${SERVICE_ACTIVITIES}/${id}`).then(({ data }) => data)
